
$(document).ready(function () {
  if (window.matchMedia('(max-width: 767px)').matches) {
$('.main-style-first').hide();
  }else{
  $(window).on("scroll", function () {
    // Show & Hide Text On-Scroll
    if ($(window).scrollTop() > 550) {
     
     $('.main-style-first').show(1000);

      $(".tab-main").fadeOut(1000);
      $('.main-swatches-custome').fadeOut(1000);
    } else {
      $(".tab-main").fadeIn(600);
      $('.main-swatches-custome').fadeIn(600);
      
       $('.main-style-first').hide(300);
    }
  });
  }
  
    $(".trigger_popup_fricc").click(function(){
       $('.hover_bkgr_fricc').show();
    });
  
    $('.popupCloseButton').click(function(){
        $('.hover_bkgr_fricc').hide();
    });

});


$(document).ready(function(){
 var firstvale= $('.swatch-thumb.default:first').attr('data-color');
  $('.curstom-color').find('.color-name').html(firstvale);
  
  $('.color-metafields .swatch-thumb').mouseover(function(){
    var colorname = $(this).addClass('active').attr('data-color');
    $('.curstom-color').find('.color-name').html(colorname);
  });
  $('.color-metafields .swatch-thumb').mouseout(function(){
    $(this).removeClass('active');
  });
   var htmsj = $('.product-main').find('.product_section').find('.product-details-wrapper').find('.modal_price').find('.price-ui').find('.sold_out').html();

  if(htmsj=='Sold out'){
$('.customdisablebtn').show();
  $('.main-addtocart').hide();
  $('.styled-product-wrapper').find('.styled-product').each(function(index,value) {
    $(this).find('.swatch_options').find('.size').find('.custom-items').find('.swatch-all').find('.swatch-element22').first().trigger('click');
  });
}else{
  $('.customdisablebtn').hide();
  $('.main-addtocart').show();
}
});




$('.styled-product-wrapper .thirsmetavalue .swatch_options .size .option-contenet .swatch-all .swatch-element22').click(function () {
var tttvalue= $(this).attr('data-metavid');
  $(this).parents('.custom-items').find('.swatch-all').find('.swatch-element22').removeClass('active');
  $(this).addClass('active');
  if ($(this).hasClass("available")) {
    $(this).parents('.swatch_options').siblings('form').find('#variant-id-input-2').val(tttvalue);
    $(this).parents('.swatch_options').siblings('form').find('.style-with-button').removeClass('disabled').find('.text').html('Add to Cart');
 $(this).parents('.swatch_options').siblings('form').find('.metafield-btn').prop("disabled", false);
  }else if($(this).hasClass("soldout")) {
   $(this).parents('.swatch_options').siblings('form').find('.style-with-button').addClass('disabled').find('.text').html('Join the Waitlist');
    
  }else{
    //alert('else');
  }
  //alert(tttvalue);
});

$('.styled-product-wrapper .second2 .swatch_options .size .option-contenet .swatch-all .swatch-element22').click(function () {
var tttvalue= $(this).attr('data-metavid');
  $(this).parents('.custom-items').find('.swatch-all').find('.swatch-element22').removeClass('active');
  $(this).addClass('active');
  if ($(this).hasClass("available")) {
    $(this).parents('.swatch_options').siblings('form').find('#variant-id-input-3').val(tttvalue);
    $(this).parents('.swatch_options').siblings('form').find('.style-with-button').removeClass('disabled').find('.text').html('Add to Cart');
  $(this).parents('.swatch_options').siblings('form').find('.metafield-btn').prop("disabled", false);
  }else if($(this).hasClass("soldout")) {
   $(this).parents('.swatch_options').siblings('form').find('.style-with-button').addClass('disabled').find('.text').html('Join the Waitlist');
    
  }else{
    //alert('else');
  }
  //alert(tttvalue);
});

$('.styled-product-wrapper .first-varaint .swatch_options .size .option-contenet .swatch-all .swatch-element22').click(function () {
var tttvalue= $(this).attr('data-metavid');
  $(this).parents('.custom-items').find('.swatch-all').find('.swatch-element22').removeClass('active');
  $(this).addClass('active');
  if ($(this).hasClass("available")) {
    $(this).parents('.swatch_options').siblings('form').find('#variant-id-input').val(tttvalue);
    $(this).parents('.swatch_options').siblings('form').find('.style-with-button').removeClass('disabled').find('.text').html('Add to Cart');
    $(this).parents('.swatch_options').siblings('form').find('.metafield-btn').prop("disabled", false);
  }else if($(this).hasClass("soldout")) {
   $(this).parents('.swatch_options').siblings('form').find('.style-with-button').addClass('disabled').find('.text').html('Join the Waitlist');
    
  }else{
    //alert('else');
  }
  //alert(tttvalue);
});

$('.product-details-wrapper .custom-mainform .shopify-product-form .swatch_options .customsize .swatch-element').click(function () {  
  
  if ($(this).hasClass("available")) {
    $('.add_to_cart').find('.text.custom-main-btn').html('Add to Cart');
  }
  
  if ($(this).hasClass("soldout")) {
   
    $('.customdisablebtn').show();
  $('.main-addtocart').hide();
}else{
  $('.customdisablebtn').hide();
  $('.main-addtocart').show();

    }

});


$(".tabmain.hide li.mobile-tab").click(function(){
$(this).addClass("active");

  $(this).siblings("").removeClass("active");
});


$("li.descriptn.mobile-tab").click(function(){
$("label.product-tabs__label.tab-1").trigger("click");
});


$("li.details.mobile-tab").click(function(){
$("label.product-tabs__label.loop-1").trigger("click");
});

$("li.sizeguide.mobile-tab").click(function(){
$("label.product-tabs__label.loop-2").trigger("click");
});

$("li.style.mobile-tab").click(function(){
$("label.product-tabs__label.loop-3").trigger("click");
});


$(".widemenu .widemenu__submenu-items .secondmenu .widemenu__link").on("mouseover", function () {
    //stuff to do on mouseover
 
 var main_menu= $(this).attr('data-menu');
  $(this).addClass('active');
  var datloop = $(this).parents('.widemenu__submenu').addClass('data-avtive').attr('dataloop');
   $('.images-part .widemenu__submenu.ccc:nth-child(1) .images-section:first').removeClass('static-show-second');
  
 $('.images-part .widemenu__submenu.ccc .widemenu__submenu-items.cccgggg .images-section').each(function(){
 var thiclass = $(this).attr('data-class');
var datalopimg = $(this).parents('.widemenu__submenu').attr('data-im-loop');
 
   
if(datalopimg==datloop){
  $(this).parents('.widemenu__submenu').show();
}else{
   $(this).parents('.widemenu__submenu').hide();
}
   
    if (thiclass.length != 0) {
if(thiclass == main_menu)
{
$(this).addClass('active');
$(this).css('display','block');
   var lilenth = $(this).find('.product-images-menu li').length;
  $(this).prev().removeClass('customclass').css('display','none');
  // if(lilenth<1){
  //   $(this).prev().addClass('customclass').css('display','block');
  // }else{
  //    $(this).prev().removeClass('customclass').css('display','none');
  // }
}else{
$(this).css('display','none');
$(this).removeClass('active');
}
  }else{
//alert('not');
}
 });
});

$(".widemenu__submenu-items .secondmenu").on("mouseleave", function () {
 $(this).removeClass('active');
  $(this).parents('.widemenu__submenu').removeClass('data-avtive')
});

//$('.nav-desktop__tier-1 .nav-desktop__tier-1-item:nth-child(2)').on("mouseover", function () {
$(document).ready(function(){                                                                              
//$(".widemenu").find('.widemenu__submenu:nth-child(2)').find('.widemenu__submenu-items .widemenu__submenu-item:first').addClass('active');
  $('.images-part .widemenu__submenu.ccc:nth-child(1)').addClass('static-show');
  $('.images-part .widemenu__submenu.ccc:nth-child(1) .images-section:first').addClass('static-show-second');
  
});